import React, { useState, useEffect } from 'react';
import './AnnouncementBar.css';

export default function AnnouncementBar() {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    // Reflect announcement presence on the body so header/layout can adapt
    if (visible) {
      document.body.classList.add('has-announcement');
    } else {
      document.body.classList.remove('has-announcement');
    }
    return () => document.body.classList.remove('has-announcement');
  }, [visible]);

  if (!visible) return null;

  return (
    <div className="announcement">
      <div className="announcement-content">
        <div className="announcement-text">
          <span className="announcement-badge">New</span>
          Limited-time offer: Upgrade today and unlock exclusive features with special pricing for qualifying customers 🚀
        <a href="#" className="announcement-link">
          Learn more →
        </a>
        </div>
      </div>

      <button
        className="announcement-close"
        aria-label="Dismiss notification"
        onClick={() => setVisible(false)}
      >
        ✕
      </button>
    </div>
  );
}
